import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {DraftJobSplitPlan} from "../../../models/draft-job-split-plan.model";

require('./planning-draft-job-split-plan.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-job-split-plan',
  templateUrl: './planning-draft-job-split-plan.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobSplitPlanComponent {
  @Input() splitPlan: DraftJobSplitPlan;
}
